<template>
  <label class="checkbox">
    <input v-model="isVisibleLogo" type="checkbox" />
    <span class="checkbox-ui">
      <IconCheck></IconCheck>
    </span>
    {{ isVisibleLogo ? t('sconai_logo_visible') : t('sconai_logo_invisible') }}
  </label>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import IconCheck from '@/components/icons/IconCheck.vue';

const isVisibleLogo = defineModel<boolean>({
  required: true,
  default: true,
});

const { t } = useI18n();
</script>

<style scoped lang="scss">
label {
  color: var(--font-default);
}
</style>
